'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { CamelCaseOptions, LegalConsentOptions } from 'FormsCommonComponents/constants/LegalConsent';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `formsLegalText.selectOption.${suffix}`;
export default class LegalConsentOptionSelectInput extends PureComponent {
  getOptions() {
    return Object.values(LegalConsentOptions || {}).map(option => {
      const camelCaseOption = CamelCaseOptions[option];
      return {
        value: option,
        text: I18n.text(i18nKey(`options.${camelCaseOption}.text`)),
        help: I18n.text(i18nKey(`options.${camelCaseOption}.help`))
      };
    });
  }
  render() {
    const {
      buttonUse,
      option,
      onChange
    } = this.props;
    return /*#__PURE__*/_jsx(Select, {
      buttonUse: buttonUse,
      "data-test-id": "select-GDPR-option",
      searchable: false,
      options: this.getOptions(),
      value: option,
      onChange: ({
        target: {
          value
        }
      }) => onChange(value)
    });
  }
}
LegalConsentOptionSelectInput.propTypes = {
  buttonUse: PropTypes.string.isRequired,
  option: PropTypes.oneOf(Object.values(LegalConsentOptions || {})).isRequired,
  onChange: PropTypes.func.isRequired
};